import { render, staticRenderFns } from "./CirclesProportionalPublicDisplayItem.vue?vue&type=template&id=11defdaa"
import script from "./CirclesProportionalPublicDisplayItem.vue?vue&type=script&lang=js"
export * from "./CirclesProportionalPublicDisplayItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11defdaa')) {
      api.createRecord('11defdaa', component.options)
    } else {
      api.reload('11defdaa', component.options)
    }
    module.hot.accept("./CirclesProportionalPublicDisplayItem.vue?vue&type=template&id=11defdaa", function () {
      api.rerender('11defdaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/CirclesProportionalPublicDisplayItem.vue"
export default component.exports